import { render, staticRenderFns } from "./JImageCard.vue?vue&type=template&id=b514853c"
import script from "./JImageCard.vue?vue&type=script&lang=ts"
export * from "./JImageCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports